<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="90px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="商户名称">
                 <el-input
                    clearable
                    v-model="queryParamForm.merchantName"
                  ></el-input
                >
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getCommissionListSearch"
              >查询</el-button
            >
            <el-button type="primary" @click="addBasePrice">创建</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="merchantName" label="商户名称"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">启用</span>
            <span v-else>不启用</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="配置人"> </el-table-column>
        <el-table-column prop="modifyTime" label="更新时间"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >启用</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不启用</el-button
            >
            <el-button @click="deleteCommission(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="
        dlgType === 'change'
          ? '编辑利润扣款'
          : '新建利润扣款'
      "
      :visible.sync="isDlg"
      width="1300px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editProfitCostForm"
            :model="editProfitCostForm"
            :rules="editorFormRules"
            label-width="120px"
            label-position="left"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editProfitCostForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="商户名称" prop="merchantId">
              <el-select
                v-model="editProfitCostForm.merchantId"
                filterable
              >
                <el-option
                  v-for="item in validMerchantOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <div>
                 <div>
                  <el-row :gutter="10" style="margin-bottom:20px">
                    <el-col :span="6"><span style="color:red">* </span>价格段</el-col>
                    <el-col  :span="4"><span style="color:red">* </span>佣金</el-col>
                    <el-col  :span="4"><span style="color:red">* </span>店员红包</el-col>
                    <el-col  :span="4"><span style="color:red">* </span>店长红包</el-col>
                    <el-col  :span="4"><span style="color:red"> </span>关键人奖励</el-col>
                    <el-col  :span="1"></el-col>
                  </el-row>
                  </div>
                  <div
                      v-for="(item, itemIndex) in commissionCombProject"
                      :key="item.id"
                      style="margin-bottom:4px"
                    >
                      <commission-item
                        :commission-item-object="item"
                        :item-index="itemIndex"
                        @getItemCommissionValue="getItemCommissionValue"
                        @deleteCommissionItem="deleteCommissionItem"
                      ></commission-item>
                   
                    </div>
                    <el-button
                      icon="el-icon-circle-plus-outline"
                      @click="addCondition(itemIndex)"
                    ></el-button>
            </div>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      queryParamForm: {
        merchantName: null,
      },
      commissionCombProject:[{
        priceStart: null,
        priceEnd: null,
        commission: null,
        redPackage: null,
        employeeRedPackage:null,
        commissionType:1,
        redType:1,
        employeeRedType:1}],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editProfitCostForm: {
        id: null,
        value: null,
        merchantId: null,
        commissionCondition:null
      },

      editorFormRules: {
        merchantId: [
          { required: true, message: "请选择商户名称", trigger: "change" },
        ],
      },

      dlgType: "change",

      // 选择
      loading: false,
      validMerchantOptions: [],
      isRefresh: false
    };
  },
  watch: {},
  computed: {},
  methods: {
     deleteCommission(id){
      let self = this
        self.$confirm('是否删除').then(() => {
         self.$api.deleteCommission({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getCommissionListSearch()
          }
      })
      })
     
    },
    deleteCommissionItem(itemIndex){
      let self = this
      this.commissionCombProject.splice(itemIndex,1);
      self.isRefresh = false;
        this.$nextTick(() => {
          self.isRefresh = true;
        });
    },
    addCondition() {
      this.commissionCombProject.push({
        priceStart: null,
        priceEnd: null,
        commission: null,
        redPackage: null,
        employeeRedPackage:null,
        commissionType:1,
        redType:1,
        employeeRedType:1});
    },
    //获取子组件的值
    getItemCommissionValue(itemIndex, evalItemObject) {
      this.commissionCombProject[itemIndex] = evalItemObject;
    },

    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getCommissionListSearch();
    },

    // 获取表格数据
    getCommissionListSearch() {
      let self = this;
      self.$api
        .commissionListSearch({
          page: self.currentPage,
          size: self.pageSize,
          merchantName: self.queryParamForm.merchantName || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addBasePrice() {
      this.dlgType = "new";
      this.editProfitCostForm = {
        id: null,
        value: null,
        merchantId: null,
        commissionCondition:null
      };
      this.$nextTick(()=>{
          this.$refs['editProfitCostForm'].clearValidate()
      })
      this.commissionCombProject = [{
        priceStart: null,
        priceEnd: null,
        commission: null,
        redPackage: null,
        employeeRedPackage:null,
        commissionType:1,
        redType:1,
        employeeRedType:1}]
      this.isDlg = true;
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.dlgType = "change";
      self.editProfitCostForm = JSON.parse(JSON.stringify(row));
      self.commissionCombProject = JSON.parse(row.commissionCondition)
      this.isDlg = false;
      this.$nextTick((e) => {
        self.isDlg = true;
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editProfitCostForm"].validate((valid) => {
        if (valid) {
          let params = this.editProfitCostForm;
          if(self.commissionCombProject==null||self.commissionCombProject.length<=0){
                      this.$message({
                        message: "请设置佣金红包规则",
                        type: "error",
                      }); 
                      return
          }
            for(let i=0;i<self.commissionCombProject.length;i++){
                 var item = self.commissionCombProject[i]
                 if(item.priceStart==''||item.priceEnd==''||item.commission==''||item.redPackage==''||item.employeeRedPackage==''||
                 item.priceStart==null||item.priceEnd==null||item.commission==null||item.redPackage==null||item.employeeRedPackage==null){
                      this.$message({
                        message: "佣金红包设置值不能为空",
                        type: "error",
                      }); 
                      return
                 }
            }
          params.commissionCondition = JSON.stringify(self.commissionCombProject)
          self.$api.updateCommission(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getCommissionListSearch();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getValidMerchant() {
      let self = this;
      this.$api
        .getValidMerchant()
        .then((res) => {
          self.validMerchantOptions = res.data || [];
        });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      row.modelId = null;
      this.$api.updateCommission(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getCommissionListSearch();
        }
      });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getCommissionListSearch();
    self.getValidMerchant();
  },
};
</script>
<style lang="less" scoped>
.topselect {
  ::v-deep {
    .el-input__inner {
      height: 120px;
    }

    .el-input__prefix,
    .el-input__suffix {
      height: 120px;
    }

    /* 下面设置右侧按钮居中 */
    .el-input__suffix {
      top: 5px;
    }

    .el-input__icon {
      line-height: inherit;
    }

    .el-input__suffix-inner {
      display: inline-block;
    }
  }
}
</style>
